import manifest from './player_icons.json';

/**
 * In-game player icons, exported from the game with `npm run export-icons`.
 * Mirrors PlayerIconData.GetIcon / GetIconBorder in the game: icons 0-99 are
 * the default icons, 100+ are special icons, and anything unknown falls back
 * to icon 0 (the basket).
 */
const BASE_URL = `${process.env.PUBLIC_URL}/player_icons`;

/** The tournament pack border, which the game draws with an extra glow. */
export const TOURNAMENT_ICON_BORDER = 1;

export const playerIconUrl = (icon: number | undefined): string | undefined => {
    if (icon === undefined || icon === null) return undefined;

    const { iconCount, specialIconOffset, specialIconCount } = manifest;
    const known = icon >= specialIconOffset
        ? icon < specialIconOffset + specialIconCount
        : icon >= 0 && icon < iconCount;

    return `${BASE_URL}/${known ? icon : 0}.webp`;
};

export interface IconSelection {
    icon: number;
    iconBorder: number;
}

/**
 * The icon a player has picked. The game stores the choice in `iconInfo`;
 * the top level `icon` and `b` / `iconFrame` are legacy values that the game
 * no longer updates when the player changes icon, so they are only a fallback
 * for players who never got an `iconInfo` (mirrors PlayerSave.GetPlayerIconInfo).
 */
export const resolveIconSelection = (source: any): IconSelection => {
    const info = source?.iconInfo;
    if (info && info.icon !== undefined && info.icon !== null) {
        return { icon: info.icon, iconBorder: info.iconBorder ?? 0 };
    }
    return { icon: source?.icon ?? 0, iconBorder: source?.b ?? source?.iconFrame ?? 0 };
};

/** Border overlay for the icon, or undefined when the player has none. */
export const playerIconBorderUrl = (border: number | undefined): string | undefined => {
    if (!border || border < 0 || !manifest.borderKeys.includes(border)) return undefined;
    return `${BASE_URL}/borders/${border}.webp`;
};
